const categoryIcons = {
	"Research": "bi-journal-text",
	"Call": "bi-telephone",
	"Outside": "bi-tree",
	"Programming": "bi-code-slash",
	"Online Chore": "bi-check2-square",
	"Testing": "bi-bug",
	"Meeting": "bi-people",
	"Check Issues": "bi-exclamation-circle",
	"Submit PR": "bi-box-arrow-up",
	"Develop for ZACT": "bi-tools",
	"PERSONAL": "bi-person",
	"WORK": "bi-briefcase",
	"Read/Reply Email": "bi-envelope",
	"Design For ZACT": "bi-palette",
	"Review PR": "bi-eye",
	"Online Training": "bi-mortarboard",
	"Ecom Purchase": "bi-cart",
	"Office Visit(incl Saturday)": "bi-building",
	"Home Chores": "bi-house",
	"Chat": "bi-chat",
	"Office Visit": "bi-building",
	"Documentation": "bi-file-text",
};

export function getCategoryIcon(name) {
	return categoryIcons[name] || "bi-tag";
}
